import { actionCreator } from '../../../helpers/utils';

// Checkbox
export const SELECT_CHECKBOX_STUDENT = 'SELECT_CHECKBOX_STUDENT';
export const SELECT_ALL_CHECKBOX_STUDENT = 'SELECT_ALL_CHECKBOX_STUDENT';

const selectCheckboxStudent = profileId => async (dispatch) => {
    const selectStudentAction = actionCreator(SELECT_CHECKBOX_STUDENT, {
        data: profileId
    });
    dispatch(selectStudentAction);
};

const selectAllCheckboxStudent = () => async (dispatch) => {
    const selectAllStudentAction = actionCreator(SELECT_ALL_CHECKBOX_STUDENT);
    dispatch(selectAllStudentAction);
};

export default {
    selectCheckboxStudent,
    selectAllCheckboxStudent
};



// WEBPACK FOOTER //
// ./containers/console/actions/student-selection-actions.js